<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-back-button defaultHref="/" :text="$t('g.back')"></ion-back-button>
        </ion-buttons>
        <ion-buttons slot="end">
          <ion-button @click="isModalOpen = true">Signer</ion-button>
        </ion-buttons>
        <ion-title>Utilisation de la machine à café</ion-title>
      </ion-toolbar>
    </ion-header>

    <ion-content>
      <ion-modal ref="modal" :is-open="isModalOpen">
        <ion-header>
          <ion-toolbar>
            <ion-title>Signature</ion-title>
          </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
          <div>
            <ion-checkbox label-placement="end">Je confirme avoir pris connaissance du document</ion-checkbox>
          </div>
          <p>Signer ci-dessous</p>
          <div
            style="background-color: white; border: 1px solid gray; height: 300px;  margin: 20px auto">
          </div>
          <ion-button expand="block" :strong="true" @click="closeModal()">Valider</ion-button>
          <ion-button expand="block" :strong="true" fill="outline" @click="closeModal()">Annuler</ion-button>
        </ion-content>
      </ion-modal>

      <div style="margin-left: auto; margin-right: auto; width: 100%;">
        <video controls src="assets/video/IMG_3416.MOV" style="width: 100%;"></video>
      </div>
    </ion-content>
  </ion-page>
</template>

<script lang="ts" setup>
import {
  IonContent, IonHeader, IonPage, IonButtons,
  IonTitle, IonBackButton, IonButton,
  IonModal, IonCheckbox, 
  IonToolbar, onIonViewDidEnter
} from '@ionic/vue';
import { ref } from 'vue';
import { useAuthStore } from '@/stores/auth.store';
import { getApi } from '@/helpers/api';
import { PeriodCountersApi, DtoCounter } from 'ppf-api-client';


const counters = ref<DtoCounter[]>([]);
const loading = ref(true);

const service = getApi(PeriodCountersApi);
const auth = useAuthStore();
const isModalOpen = ref(false);

//load inital data when entering the tab
onIonViewDidEnter(() => {
  loading.value = true;
  counters.value = [];

  service.periodCountersByPersonnel(auth.userId, new Date()).then(r => {
    counters.value = r.sort((a, b) => a.index - b.index);
    loading.value = false;
  });
});

function closeModal() {
  isModalOpen.value = false;
}

</script>

<style scoped></style>
